import configurationStore from '../../store/backoffice/configuration'

export default {
  install: function (Vue,) {
    Vue.prototype.$priceWithVat = function (price, vat = null) {
      const p = parseFloat(price)
//       return (parseFloat(price) + (parseFloat(price) * configurationStore.state.commercial.commercial_vat_rate.value)).toFixed(2)
      let vatRate = configurationStore.state.commercial.commercial_vat_rate.value
      if (vat !== null) {
        vatRate = vat
      }
      return (p + (p * vatRate))
    }

    Vue.prototype.$priceWithoutVat = function (price, vat = null) {
      let vatRate = configurationStore.state.commercial.commercial_vat_rate.value
      if (vat !== null) {
        vatRate = vat
      }
      return (price / (1 + vatRate)).toFixed(2)
    }
    Vue.prototype.$defaultVat = function (vat = null) {
      let vatRate =  configurationStore.state.commercial.commercial_vat_rate.value
      return vatRate * 100
    }

    Vue.prototype.$priceWithcurrency = function (price) {
      return `${configurationStore.state.commercial.commercial_currency.value}${price}`
    }

    Vue.prototype.$vatPart = function (price, vat = null) {
      const p = parseFloat(price)
      let vatRate = configurationStore.state.commercial.commercial_vat_rate.value
      if (vat !== null) {
        vatRate = vat
      }
      return (p / (1 + (vatRate)))
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/plugins/currency.js